import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { axiosVal as axios } from "..";

const initialState = {
    loaded: false,
    isLoggedin: false,
    logout: false,
    progress: false,
    studios: [],
    user: {},
    userAccount: {},
    searchResults: [],
    accountUpdated: false,
    accountDeleted: false,
    error: {
        status: false,
        message: ""
    },
    success: {
        status: false,
        message: ""
    },
};

const getToken = () => "LiveBearer " + localStorage.getItem('auth-token');

export const getStudios = createAsyncThunk('studios/get', async () => {
    try {
        const response = await axios.get(
            "/studios/",
            {
                headers: {
                    'x-auth': getToken(),
                },
            }
        );
        return response.data;
    } catch (error) {
        throw error.response.data;
    }
});

export const getStudioDetails = createAsyncThunk('dealers/getStudioDetails', async (id) => {
    try {
        const response = await axios.get(
            `/studios/${id}`,
            {
                headers: {
                    'x-auth': getToken(),
                },
            }
        );
        return response.data;
    } catch (error) {
        throw error.response?.data || error.message;
    }
});

export const updateStudioDetails = createAsyncThunk(
    'studio/updateStudioDetails', 
    async ({ studioId, updatedData }) => {
        try {
            const response = await axios.put(
                `/studios/${studioId}`,
                updatedData,
                {
                    headers: {
                        'x-auth': getToken(),
                    },
                }
            );
            return response.data; 
        } catch (error) {
            throw error.response?.data || error.message; 
        }
    }
);

export const deleteStudio = createAsyncThunk(
    "studio/deleteStudio",
    async (studioId, { rejectWithValue }) => {
        try {
            await axios.delete(`/studios/${studioId}`,
                {
                    headers: {
                        'x-auth': getToken(),
                    },
                }
            );
            return studioId;
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
);

const studiosSlice = createSlice({
    name: "studios",
    initialState,
    reducers: {
        reset(state) {
            state.error.status = false;
            state.success.status = false;
        },
    },
    extraReducers: (builder) => {
        builder.addCase(getStudios.fulfilled, (state, action) => {
            state.studios = action?.payload;
        });
        builder.addCase(getStudioDetails.fulfilled, (state, action) => {
            state.studioDetails = action?.payload;
        });
        builder.addCase(updateStudioDetails.fulfilled, (state, action) => {
            state.studioDetails = action?.payload;
            state.success.status = true;
            state.error.status = false;
            state.success.message = 'Studio details updated successfully';
        });
        builder.addCase(updateStudioDetails.pending, (state) => {
            state.success.status = false;
            state.error.status = false;
        });
        builder.addCase(updateStudioDetails.rejected, (state, action) => {
            state.error.status = true;
            state.error.message = action.error.message;
        });
        builder.addCase(deleteStudio.fulfilled, (state, action) => {
            state.success.status = true;
            state.success.message = "Studio deleted successfully!";
            state.studioList = state.studioList?.filter(studio => studio.id !== action.payload);
        });
        builder.addCase(deleteStudio.rejected, (state, action) => {
            state.error.status = true;
            state.error.message = action.payload || "Failed to delete studio.";
        });
    }
});

export const studioActions = studiosSlice.actions;
export const studioReducer = studiosSlice.reducer;
